export default function () {
    return {
        customerReviews: {},
    }
}
